import styled from 'styled-components';

const TitleStyle = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: ${({ theme }) => {
    return theme.border;
  }};

  h2 {
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    font-size: ${({ theme }) => {
      return theme.fonts.size.superBig;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    margin: 0;
  }
`;
export default TitleStyle;
